<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <SectionTitle :title="label('title')"/>
      </v-col>
    </v-row>
    <v-row justify="end">
      <RequiredItemText/>
    </v-row>
    <v-row v-if="showUserName" id="realName">
      <FormItem :name="label('name')" required secret>
        <TextField
          v-model="realName"
          :name="label('name')"
          required
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row v-if="showUserName" id="realNameKana">
      <FormItem :name="label('nameKana')" required secret>
        <TextField
          v-model="realNameKana"
          :name="label('nameKana')"
          :rules="nameKanaRules"
          required
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="email">
      <FormItem :name="label('email')" required secret>
        <TextField
            v-model="email"
            :name="label('email')"
            required
            :hint="emailHint"
            :submit="submit"
            :disabled="disabledEmail"
        />
      </FormItem>
    </v-row>
    <v-row>
      <FormItem :name="label('emailSub')" secret>
        <TextField
            v-model="emailSub"
            :name="label('emailSub')"
            :hint="emailSubHint"
            :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="birthDate">
      <FormItem :name="label('birthDate')" required>
        <DateSelectField
            v-model="birthDate"
            :name="label('birthDate')"
            required
        />
      </FormItem>
    </v-row>
    <v-row id="gender">
      <FormItem :name="label('gender')" no-margin-bottom required>
        <RadioField
                v-model="gender"
                :name="label('gender')"
                row
                :items="genders"
                required
                :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="zipCode">
      <FormItem :name="label('zipCode')" required secret>
        <PostalCodeField
          v-model="zipCode"
          :name="label('zipCode')"
          required
        />
      </FormItem>
    </v-row>
    <v-row id="area">
      <FormItem :name="label('area')" no-margin-bottom required>
        <RadioField
                v-model="area"
                :name="label('area')"
                row
                :items="areas"
                required
                :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="prefecture">
      <FormItem :name="label('prefecture')" required>
        <SelectField
                v-model="prefecture"
                :name="prefectureLabel"
                :items="prefectures"
                required
                :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="address">
      <FormItem :name="label('address')" required secret>
        <TextField
          v-model="address"
          :name="label('address')"
          :max="100"
          required
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="building">
      <FormItem :name="label('building')" secret>
        <TextField
          v-model="building"
          :name="label('building')"
          :max="255"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="salary">
      <FormItem :name="label('salary')" required>
        <v-row dense>
          <v-col cols="4">
            <SalarySelectField
                v-model="salary"
                :label="label('salary')"
                required
            />
          </v-col>
        </v-row>
      </FormItem>
    </v-row>
    <v-row id="partner">
      <FormItem :name="label('partner')" no-margin-bottom secret>
        <RadioField
                v-model="partner"
                :name="label( 'partner')"
                row
                :items="partners"
                :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="qualification">
      <FormItem :name="label('qualification')">
        <TextArea
          v-model="qualification"
          :name="label('qualification')"
          :max="2000"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="language">
      <FormItem :name="label('language')">
        <v-row
            no-gutters
            v-for="(item, index) in language" :key="index">
          <v-col>{{item}}</v-col>
          <v-icon
              @click="deleteLanguage(index)"
              style="color: red"
          >mdi-close</v-icon>
        </v-row>
        <LanguageForm
            v-model="this.$data.languageData"
            @addLanguage="addLanguage"
        />
      </FormItem>
    </v-row>
    <v-row id="preferredLocation">
      <FormItem :name="label('preferredLocation')" required>
        <SelectField
            v-model="preferredLocation"
            :name="label('preferredLocation')"
            :items="preferredLocationItems"
            multi
            required
            :max="3"
        />
      </FormItem>
    </v-row>
    <v-row>
      <FormItem :name="label('picture')">
        <div style="width: 120px; margin-bottom: 16px;">
          <UserImage :src="iconUrl"/>
        </div>
        <FileSelectField
                v-model="icon"
                :name="label('picture')"
                image
                :max-size="10 * 1024 * 1024"
                :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row v-if="!isSignUp">
      <FormItem :name="label('emailReceiveSetting')" no-margin-bottom secret>
        <SwitchField
                v-model="isReceiveMail"
                :name="label('receiveNews')"
                :submit="submit"
        />
        <SwitchField
                v-model="isReceiveScout"
                :name="label('receiveScouts')"
                :submit="submit"
        />
      </FormItem>
    </v-row>
  </v-container>
</template>

<script>
  import SectionTitle from "../atoms/SectionTitle";
  import TextField from "../atoms/TextField";
  import FormItem from "../molecules/FormItem";
  import SelectField from "../atoms/SelectField";
  import moment from "moment";
  import RadioField from "../atoms/RadioField";
  import FileSelectField from "../atoms/FileSelectField";
  import LanguageForm from "../molecules/LanguageForm";
  import RequiredItemText from "../atoms/RequiredItemText";
  import ComponentMixin from "../ComponentMixin";
  import SwitchField from "../atoms/SwitchField";
  import {mapGetters} from "vuex";
  import _isEmpty from "lodash/isEmpty";
  import _isNull from "lodash/isNull";
  import _isUndefined from "lodash/isUndefined";
  import _isArray from "lodash/isArray";
  import _join from "lodash/join";
  import _map from "lodash/map";
  import _isBoolean from "lodash/isBoolean";
  import _clone from "lodash/clone";
  import {areas, countries, languages, partners} from "../../enums";
  import UserImage from "../atoms/UserImage";
  import TextArea from "@/components/atoms/TextArea";
  import DateSelectField from "@/components/molecules/DateSelectField";
  import PostalCodeField from "@/components/molecules/PostalCodeField";
  import SalarySelectField from "@/components/molecules/SalarySelectField";

  export default {
    mixins: [ComponentMixin],
    type: "organism",
    name: "ProfileDetailForm",
    props: {
      "user": {
        type: Object,
        required: true
      },
      "userCandidate": {
        type: Object,
        required: true
      },
      "userLanguages": {
        type: Array,
        required: true
      },
      "showUserName": Boolean,
      "isSignUp": {
        type: Boolean,
        default: false
      },
    },
    data () {
      return {
        iconData: null,
        languageData: {
        }
      }
    },
    computed: {
      ...mapGetters("system", ["consts"]),
      name: {
        get () {
          return this.user.name
        },
        set (value) {
          this.$emit("updateUser", {...this.user, name: value})
        }
      },
      realName: {
        get () {
          return this.user.realName
        },
        set (value) {
          this.$emit("updateUser", {...this.user, realName: value})
        }
      },
      realNameKana: {
        get () {
          return this.user.realNameKana
        },
        set (value) {
          this.$emit("updateUser", {...this.user, realNameKana: value})
        }
      },
      email: {
        get () {
          return this.user.email
        },
        set (value) {
          this.$emit("updateUser", {...this.user, email: value})
        }
      },
      emailHint () {
        if (_isEmpty(this.userCandidate.emailSub)) {
          return this.label('useEmail')
        }
        return null;
      },
      emailSub: {
        get () {
          return this.userCandidate.emailSub
        },
        set (value) {
          this.$emit("updateUserCandidate", {...this.userCandidate, emailSub: value})
        }
      },
      emailSubHint () {
        if (_isEmpty(this.userCandidate.emailSub)) {
          return null;
        }
        return this.label('useEmail')
      },
      birthDate: {
        get () {
          if (this.user.birthDate == null) {
            return null;
          }
          if (this.user.birthDate.length === 4) {
            return this.user.birthDate;
          }
          return moment(this.user.birthDate).format('YYYY-MM-DD');
        },
        set (value) {
          this.$emit("updateUser", {...this.user, birthDate: value})
        }
      },
      gender: {
        get () {
          if (this.user.gender !== null) {
            return {select: this.user.gender};
          }
          return null;
        },
        set (value) {
          this.$emit("updateUser", {...this.user, gender: value.select})
        }
      },
      icon: {
        get () {
          return this.user.iconFile
        },
        set (value) {
          this.$emit("updateUser", {...this.user, iconFile: value})
          const reader = new FileReader();
          reader.onload = (e) => {
            this.iconData = e.target.result;
          };
          reader.readAsDataURL(value);
        }
      },
      iconUrl () {
        if (this.iconData) {
          return this.iconData;
        }
        return this.userCandidate.imageUrl;
      },
      area: {
        get () {
          if (this.user.area !== null) {
            return {select: this.user.area};
          }
          return null;
        },
        set (value) {
          this.$emit("updateUser", {...this.user, area: value.select, prefecture: null})
        }
      },
      zipCode: {
        get () {
          return this.user.zipCode
        },
        set (value) {
          this.$emit("updateUser", {...this.user, zipCode: value})
        }
      },
      prefecture: {
        get () {
          return Number(this.user.prefecture);
        },
        set (value) {
          this.$emit("updateUser", {...this.user, prefecture: value})
        }
      },
      preferredLocation: {
        get () {
          return this.userCandidate.preferredLocations;
        },
        set (value) {
          this.$emit("updateUserCandidate", {...this.userCandidate, preferredLocations: value})
        }
      },
      address: {
        get () {
          return this.user.address;
        },
        set (value) {
          this.$emit("updateUser", {...this.user, address: value})
        }
      },
      building: {
        get () {
          return this.user.building
        },
        set (value) {
          this.$emit("updateUser", {...this.user, building: value})
        }
      },
      salary: {
        get () {
          return this.userCandidate.salary
        },
        set (value) {
          this.$emit("updateUserCandidate", {...this.userCandidate, salary: value})
        }
      },
      partner: {
        get () {
          if (this.userCandidate.partner !== null && this.userCandidate.partner !== undefined) {
            return {select: this.userCandidate.partner ? 1 : 0};
          }
          return null;
        },
        set (value) {
          this.$emit("updateUserCandidate", {...this.userCandidate, partner: value.select})
        }
      },
      qualification: {
        get () {
          return this.userCandidate.qualification
        },
        set (value) {
          this.$emit("updateUserCandidate", {...this.userCandidate, qualification: value})
        }
      },
      language() {
        const list = [];
        this.userLanguages.forEach(ele => {
          if(ele.language == 99) {
            list.push(ele.otherLanguage + " : " + this.toText(ele.languageLevel, this.consts.languageLevel))
          } else {
            list.push( this.toText(ele.language, this.languages) + " : " + this.toText(ele.languageLevel, this.consts.languageLevel) )
          }
        });
        return list;
      },
      jobType: {
        get () {
          if (this.user.isStudent !== null) {
            return {select: this.user.isStudent ? 1 : 0};
          }
          return null
        },
        set (value) {
          this.$emit("updateUser", {...this.user, isStudent: value.select})
        }
      },
      industry: {
        get () {
          return this.user.industry
        },
        set (value) {
          this.$emit("updateUser", {...this.user, industry: value})
        }
      },
      job: {
        get () {
          return this.user.occupation
        },
        set (value) {
          this.$emit("updateUser", {...this.user, occupation: value})
        }
      },
      companyName: {
        get () {
          return this.user.companyName
        },
        set (value) {
          this.$emit("updateUser", {...this.user, companyName: value})
        }
      },
      isReceiveMail: {
        get () {
          return this.userCandidate.isReceiveMail;
        },
        set (value) {
          this.$emit("updateUserCandidate", {...this.userCandidate, isReceiveMail: value})
        }
      },
      isReceiveScout: {
        get () {
          return this.userCandidate.isReceiveScout;
        },
        set (value) {
          this.$emit("updateUserCandidate", {...this.userCandidate, isReceiveScout: value})
        }
      },
      languages () {
        if (this.$i18n.locale === 'en'){
          return languages.en
        }
        return languages.ja
      },
      languageLevels () {
        return this.consts.languageLevels
      },
      toText () {
        return (value, items) => {
          if (_isNull(value) || _isUndefined(value) || _isNull(items) || _isUndefined(items)) {
            return ""
          }
          if (_isArray(value)) {
            return _join(_map(value, val => items.filter(item => item.value === val)[0].label), ", ")
          } else if (_isBoolean(value)) {
            return items.filter(item => item.value === (value ? 1 : 0))[0].label
          } else {
            return items.filter(item => item.value === value)[0].label
          }
        }
      },
      years () {
        const years = [];
        const currentYear = moment().year();
        for (let year = currentYear; year >= 1900; year--) {
          years.push({label: year, value: year})
        }
        return years;
      },
      genders () {
        return this.consts.gender
      },
      areas () {
        return areas[this.$i18n.locale];
      },
      prefectures () {
        if (this.user.area == 2) {
          return countries;
        }
        return this.consts.prefectures
      },
      jobTypes () {
        return this.consts.isStudent
      },
      industries () {
        return this.consts.industries
      },
      jobs () {
        return this.consts.occupation
      },
      partners () {
        return partners
      },
      prefectureLabel () {
        if (this.user.area == 2) {
          return this.label("country")
        }
        return this.label("prefecture")
      },
      preferredLocationItems() {
        return this.consts.preferredLocation
      },
      disabledEmail () {
        return this.$auth && this.$auth.user && this.$auth.user.sub && !this.$auth.user.sub.startsWith("auth0")
      },
      nameKanaRules () {
        return [
          value => {
            if (value) {
              const result = value.match(/^[ァ-ヶー\s]*$/) // eslint-disable-line
              if (!result) {
                return "全角カタカナで入力してください";
              }
            }
            return true;
          }
        ]
      },
    },
    methods: {
      submit () {},
      addLanguage () {
        const language = _clone(this.$data.languageData)
        this.userLanguages.push(language)
      },
      deleteLanguage (index) {
        this.userLanguages.splice(index, 1)
      }
    },
    components: {
      SalarySelectField,
      PostalCodeField,
      DateSelectField,
      TextArea,
      UserImage,
      SectionTitle,
      FormItem,
      TextField,
      SelectField,
      RadioField,
      FileSelectField,
      LanguageForm,
      RequiredItemText,
      SwitchField
    }
  }
</script>

<style scoped lang="sass">
.form-text
  line-height: 56px

</style>
